import { Comment } from 'antd';
export default Comment;
